import _get from 'lodash/get';
import { AUTH_STATE_LOGGEDIN } from '../clientConstants';
import getStore from '../store/configureStore';

export function isLoggedInUser(applicationState) {
	if (applicationState) {
		return _get(applicationState, 'authState') === AUTH_STATE_LOGGEDIN;
	}

	const reduxStore = getStore();
	return _get(reduxStore.getState(), 'application.authState') === AUTH_STATE_LOGGEDIN;
}

export function getUserType() {
	const reduxStore = getStore();
	return _get(reduxStore.getState(), 'application.userType');
}



// WEBPACK FOOTER //
// ./buttons/utils/authUtils.js